import dayjs from 'dayjs';
import { ContentWrapperCell } from './ContentWrapperCell';
import { Link } from 'react-router-dom';
import { InterneNotizTooltip } from '../../../components';

export function DayCell({
  date,
  interneNotiz,
}: {
  date: { date: string; weekday: string };
  interneNotiz: string;
}) {
  const year = dayjs(date.date).year();
  const month = dayjs(date.date).month() + 1;

  return (
    <ContentWrapperCell>
      <div className="flex gap-1 items-center">
        <Link
          to={`/controlling/umsatzplanung/${year}/${month}/planwerte/edit?datum=${date.date}`}>
          <span className="text-sm text-primary-blue-500 hover:text-primary-blue-400 font-semibold">
            {date.weekday + ' ' + dayjs(date.date).format('D')}
          </span>
        </Link>
        {interneNotiz.length > 0 && (
          <InterneNotizTooltip interneNotiz={interneNotiz} />
        )}
      </div>
    </ContentWrapperCell>
  );
}
